module.exports = __webpack_public_path__ + "img/payment-mastercard.32a25047.svg";